// @flow

import * as React from "react";
import { connect } from "react-redux";
import { Col, Grid, Button, Modal,SplitButton , MenuItem , ButtonToolbar   } from "react-bootstrap";
import TransferOption from "./TransferOptions";
import { postBasketData, fetchBasketData } from "../../../actions/basket";
import _ from "lodash";
import currencySymbols from "../../../utils/currencySymbols";
import "./styles.css";

type Props = {
  onSelect: Function,
  options: Object,
  onCurrencyChange: Function
};

type State = {
  key: string,
  currentCurrency: string
};

export class TransferOptionsPanel extends React.Component<Props, State> {
  props: Props;
  state: State;

  constructor(props) {
    super(props);
    this.state = {
      key: "0",
      show: false
    };
  }

  shouldComponentUpdate(nextProps) {
    if (
      nextProps.options &&
      nextProps.options.optionsStatus &&
      nextProps.options.optionsStatus.status === "unchanged"
    ) {
      return false;
    }
    return true;
  }


  HandleClickCurrency = (currency) => {
    this.props.onCurrencyChange(currency);
  };

  renderTransferOptions = () => {
    const idValueOutbound = this.props.transfers[0].id;
    const idValueInbound =
      this.props.transfers &&
      this.props.transfers[1] &&
      this.props.transfers[1].id;

    // Sort the transfer options based on totalCost in ascending order
      const sortedTransferOptions = [...this.props.options.transferOptions].sort(
        (a, b) => a.optionCost.totalCost - b.optionCost.totalCost
      );

    return sortedTransferOptions.map((options, index) => {
      return (
        <Col className="transfer-option" key={index}>
          <TransferOption
            onSelect={this.props.onSelect}
            currency={currencySymbols[this.props.options.currency[0]]}
            data={options}
            postBasketData={this.props.postBasketData}
            basketId={this.props.basketId}
            qID={this.props.qID}
            idValueInbound={idValueInbound}
            idValueOutbound={idValueOutbound}
          />
        </Col>
      );
    });
  };


  renderAvailableCurrencies = () => {

    return <ButtonToolbar>
    <SplitButton
  bsStyle="success"
  className="e-round-corner"
  title={this.props.options.currency}>
   { _.map(this.props.options.availableCurrencies, currency => {
      if (currencySymbols[currency] !== undefined) {
        const background =
          currency === this.props.options.currency[0] ? "#d1d3d6" : "";
        return (
          <MenuItem
            onClick={() => this.HandleClickCurrency(currency)}
            key={currency}
            style={{ background }} >
            <strong>{currencySymbols[currency]}</strong>
          </MenuItem>
        );
      }
    })}
</SplitButton>
</ButtonToolbar>
  };

  

  render() {
    let close = () => this.setState({ show: false });
    if (this.props.options && this.props.options.error_messages) {
      return (
        <Modal
          show={this.state.show}
          onHide={close}
          container={this}
          aria-labelledby="contained-modal-title"
        >
          <Modal.Header closeButton>
            <Modal.Title id="contained-modal-title">Message</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="text-center">
              <div
                dangerouslySetInnerHTML={{
                  __html: this.props.options.optionsStatus.message.title
                }}
                style={{ fontSize: "18px", marginBottom: "20px" }}
              />
              <div
                dangerouslySetInnerHTML={{
                  __html: this.props.options.optionsStatus.message.content
                }}
              />
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button onClick={close}>Close</Button>
          </Modal.Footer>
        </Modal>
      );
    }
    if (
      this.props.options &&
      this.props.options.optionsStatus &&
      this.props.options.optionsStatus.status === "none"
    ) {
      return (
        <div className="text-center">
          <div
            dangerouslySetInnerHTML={{
              __html: this.props.options.optionsStatus.message.title
            }}
            style={{ fontSize: "18px", marginBottom: "20px" }}
          />
          <div
            dangerouslySetInnerHTML={{
              __html: this.props.options.optionsStatus.message.content
            }}
          />
        </div>
      );
    }
    return (
      <Grid className="transfer-options-panel">
        <div  className="transfer-options-banner">
        <div className="top-header ">
          <h3>
            <strong>
            Free Cancellation up to 7 days prior. No hidden fees.
            </strong>
          </h3>
        </div >
        <div className="currencies">
            {this.props.options && this.props.options.availableCurrencies
              ? this.renderAvailableCurrencies()
              : null}
          </div>
        </div>
        <div className="transfer-options-wrapper ">
  
          <div className="info-container">
            {this.props.options && this.props.options.transferOptions
              ? this.renderTransferOptions()
              : null}
          </div>
        </div>
      </Grid>
    );
  }
}

export default connect(null, { postBasketData,fetchBasketData })(TransferOptionsPanel);



// WEBPACK FOOTER //
// ./src/containers/QuotePage/TransferOptionsPanel/index.js